import '@wangeditor/editor/dist/css/style.css' // 引入 css

import React, { useState, useEffect } from 'react'
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor'
import { message } from 'antd'

function MyEditor(props) {
    const {
        showResult = false,
        showToolBar = true,
        showCopyBtn = false,
        showBorder = true,
        readOnly = false,
        placeholder = '文章内容...',
        height = 'auto',
        content = '',
        onChange,
    } = props;

    // editor 实例
    // const [editor, setEditor] = useState<IDomEditor | null>(null) // TS 语法
    const [editor, setEditor] = useState(null)                   // JS 语法

    // 编辑器内容
    // const [html, setHtml] = useState('<p>hello</p>')
    const [html, setHtml] = useState(content)
    // 模拟 ajax 请求，异步设置 html
    // useEffect(() => {
    //     setTimeout(() => {
    //         setHtml('<p>hello world</p>')
    //     }, 1500)
    // }, [])

    // 工具栏配置
    // const toolbarConfig: Partial<IToolbarConfig> = {} // TS 语法
    const toolbarConfig = { }                        // JS 语法

    // 编辑器配置
    // const editorConfig: Partial<IEditorConfig> = {
        // TS 语法
    const editorConfig = {                         // JS 语法
        placeholder,
        readOnly,

        MENU_CONF: {
            uploadImage: {
                // 小于该值就插入 base64 格式（而不上传），默认为 0
                base64LimitSize: 5 * 1024 * 1024, // 5mb
            }
        }
    }

    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])

    return (
        <>
            <div style={{ border: showBorder ? '1px solid #ccc' : 'none', zIndex: 100 }}>
                {
                    showToolBar && (
                        <Toolbar
                            editor={editor}
                            defaultConfig={toolbarConfig}
                            mode="default"
                            style={{ borderBottom: '1px solid #ccc' }}
                        />
                    )
                }
                <Editor
                    defaultConfig={editorConfig}
                    value={html}
                    onCreated={setEditor}
                    onChange={(editor) => { const html = editor.getHtml(); setHtml(html); onChange?.(html); }}
                    mode="default"
                    style={{ height, overflowY: 'hidden' }}
                />
            </div>
            <div style={{marginTop: '15px'}}>
                {
                    showCopyBtn && (
                        <button onClick={() => {
                            navigator.clipboard.writeText(html).then(() => {
                                message.success('复制成功！');
                            }).catch(() => {
                                message.error('复制失败，请手动复制');
                            });
                        }}>
                            复制结果
                        </button>
                    )
                }
                {showResult && <div style={{marginTop: '15px'}}>{html}</div>}
            </div>
        </>
    )
}

export default MyEditor;
